import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    tap((event: any) => {
      if (event?.body?.status === '401') {
        router.navigate(['/auth/logout'], { queryParams: { reason: 'session_expired' } });
      }
    })
  );
};
